import React from 'react'
import type { SvgProps } from 'src/shared/types/svg-props-type'

export const CodeCircle03Icon = (props?: SvgProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="#B0B2B6"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{props?.title}</title>
      <path d="M21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12ZM12.0195 6.80371C12.1279 6.26226 12.6548 5.91123 13.1963 6.01953C13.7377 6.12793 14.0888 6.65479 13.9805 7.19629L11.9805 17.1963C11.8721 17.7377 11.3452 18.0888 10.8037 17.9805C10.2623 17.8721 9.91123 17.3452 10.0195 16.8037L12.0195 6.80371ZM7.79297 8.29297C8.18349 7.90244 8.81651 7.90244 9.20703 8.29297C9.59756 8.68349 9.59756 9.31651 9.20703 9.70703L6.91406 12L9.20703 14.293L9.27539 14.3691C9.59574 14.7619 9.57315 15.3409 9.20703 15.707C8.84092 16.0731 8.26191 16.0957 7.86914 15.7754L7.79297 15.707L4.79297 12.707C4.40244 12.3165 4.40244 11.6835 4.79297 11.293L7.79297 8.29297ZM14.793 8.29297C15.1591 7.92685 15.7381 7.90426 16.1309 8.22461L16.207 8.29297L19.207 11.293C19.5976 11.6835 19.5976 12.3165 19.207 12.707L16.207 15.707C15.8165 16.0976 15.1835 16.0976 14.793 15.707C14.4024 15.3165 14.4024 14.6835 14.793 14.293L17.0859 12L14.793 9.70703L14.7246 9.63086C14.4043 9.23809 14.4269 8.65908 14.793 8.29297ZM23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z" />
    </svg>
  )
}
